import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Login from '../../pages/Login'
import NotFound from '../../pages/NotFound'
import { addLocale, locale } from 'primereact/api'
import PdaMenu from '../../pages/menu/pda-menu'
import InboundMenu from '../../pages/menu/inbound-menu'
import OutboundMenu from '../../pages/menu/outbound-menu'
import InventoryMenu from '../../pages/menu/inventory-menu'
import Incoming from '../../pages/inbound/incoming'
import IncomingDetail from '../../pages/inbound/incoming-detail'
import MidmileIncoming from '../../pages/inbound/midmile/midmile-incoming'
import PiecePicking from '../../pages/outbound/piece-picking'
import PiecePickingOld from '../../pages/outbound/piece-picking-old'
import PiecePickingStatus from '../../pages/outbound/piece-picking-status'
import TotalPicking from '../../pages/outbound/total-picking'
import { CommonContext } from '../common/context/commonContext'
import MiddleMile from '../../pages/outbound/middle-mile'
import LocationRegist from '../../pages/inventory/location-regist'
import InventorySurvey from '../../pages/inventory/inventory-survey'
import InventorySupplement from '../../pages/inventory/inventory-supplement'
import InventoryList from '../../pages/inventory/inventory-list'
import LocationDetail from '../../pages/inventory/location-detail'
import UnusedLocation from '../../pages/inventory/location/unusedLocation'
import InboundLocation from '../../pages/inventory/location/inboundLocation'
import PickingLocation from '../location/pickingLocation'
import TakebackLocation from '../location/takebackLocation'
import ReturnLocation from '../location/returnLocation'
import SluggishInventoryLocation from '../location/sluggishInventoryLocation'
import TakebackInbound from '../../pages/inbound/takeback/takeback-inbound'
import GoodsList from '../../pages/goods/goods-list'
import LocationSave from '../../pages/inventory/location-save'
import InventorySurveyInfo from '../../pages/inventory/inventory-survey-info'
import InventorySupplementScan from "../../pages/inventory/inventory-supplement-scan";
import InventorySurveyLocationDetail from "../../pages/inventory/inventory-survey-location-detail";
import App from '../../App'
import { useTranslation } from 'react-i18next'

const AppWrapper = () => {
    const location = useLocation()
    const path = location.pathname
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation();

    addLocale('kr', {
        firstDayOfWeek: 1,
        dayNames: ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'],
        dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
        dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
        monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        today: '오늘',
        clear: '초기화',
    })

    locale('kr')

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])

    useEffect(() => {
        $http().get('/whoami').then()
    }, [$http])

    switch (path) {
        case '/login':
            return <Login />
        case '/notfound':
            return <NotFound />
        case '/':
            return <PdaMenu />
        case '/inbound':
            return <InboundMenu />
        case '/incoming':
            return <Incoming />
        case '/incoming-detail':
            return <IncomingDetail />
        case '/midmile-incoming':
            return <MidmileIncoming />
        case '/outbound':
            return <OutboundMenu />
        case '/outbound/total-picking':
            return <TotalPicking />
        case '/outbound/piece-picking':
            return <PiecePicking />
        case '/outbound/piece-picking-old':
            return <PiecePickingOld />
        case '/outbound/piece-picking/status':
            return <PiecePickingStatus />
        case '/outbound/middle-mile':
            return <MiddleMile />
        case '/inventory':
            return <InventoryMenu />
        case '/takeback-inbound':
            return <TakebackInbound />
        case '/inventory-list':
            return <InventoryList />
        case '/location-detail':
            return <LocationDetail />
        case '/inventory-supplement':
            return <InventorySupplement />
        case '/inventory-supplement-scan':
            return <InventorySupplementScan />
        case '/inventory-survey':
            return <InventorySurvey />
        case '/inventory-survey-info':
            return <InventorySurveyInfo />
        case '/inventory-survey-location-detail':
            return <InventorySurveyLocationDetail />
        case '/location-regist':
            return <LocationRegist />
        case '/location-save':
            return <LocationSave />
        case '/sluggish-inventory-location':
            return <SluggishInventoryLocation />
        case '/unused-location':
            return <UnusedLocation />
        case '/inbound-location':
            return <InboundLocation />
        case '/picking-location':
            return <PickingLocation />
        case '/takeback-location':
            return <TakebackLocation />
        case '/return-location':
            return <ReturnLocation />
        case '/goods':
            return <GoodsList />
        default:
            return <App/>
    }
}

export default AppWrapper
